import { Col, Offcanvas, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { FaFileSignature, FaFolder, FaHome, FaProjectDiagram, FaThList, FaUsers, FaWhatsapp } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { IoCalendarSharp } from "react-icons/io5";
import { FaGear } from "react-icons/fa6";
import classes from './ModulesSideModal.module.css';
import { TfiEmail } from "react-icons/tfi";

const ModulesSideModal = ({ show, setShow }) => {
    const rtl = useSelector(state => state.lc.rtl);

    const handelCloseModal = () => {
        setShow(false);
    }

    return (
        <Offcanvas className={classes.offcanvas} show={show} onHide={handelCloseModal} placement={rtl ? 'end' : 'start'} keyboard={false}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Modules</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <Row>
                    <Col xs={4}>
                        <Link to="/sys" onClick={handelCloseModal}>
                            <div className={classes.moduleBox + ' shadow'} >
                                <div className={classes.moduleIcon}><FaHome /></div>
                                <div className={classes.moduleName + ' px-1 pb-2'}>Dashboard</div>
                            </div>
                        </Link>
                    </Col>

                    <Col xs={4}>
                        <Link to="/sys/lists" onClick={handelCloseModal}>
                            <div className={classes.moduleBox + ' shadow'} >
                                <div className={classes.moduleIcon}><FaThList /></div>
                                <div className={classes.moduleName + ' px-1 pb-2'}>Lists</div>
                            </div>
                        </Link>
                    </Col>

                    <Col xs={4}>
                        <Link to="/sys" onClick={handelCloseModal}>
                            <div className={classes.moduleBox + ' shadow'} >
                                <div className={classes.moduleIcon}><FaUsers /></div>
                                <div className={classes.moduleName + ' px-1 pb-2'}>Contacts</div>
                            </div>
                        </Link>
                    </Col>

                    <Col xs={4}>
                        <Link to="/sys/forms" onClick={handelCloseModal}>
                            <div className={classes.moduleBox + ' shadow'} >
                                <div className={classes.moduleIcon}><FaFileSignature /></div>
                                <div className={classes.moduleName + ' px-1 pb-2'}>Forms</div>
                                {/* <div className={classes.moduleName + ' px-1 pb-2'}>File Signature</div> */}
                            </div>
                        </Link>
                    </Col>

                    <Col xs={4}>
                        <Link to="/sys" onClick={handelCloseModal}>
                            <div className={classes.moduleBox + ' shadow'} >
                                <div className={classes.moduleIcon}><FaWhatsapp /></div>
                                <div className={classes.moduleName + ' px-1 pb-2'}>Whatsapp Bot</div>
                            </div>
                        </Link>
                    </Col>

                    <Col xs={4}>
                        <Link to="/sys" onClick={handelCloseModal}>
                            <div className={classes.moduleBox + ' shadow'} >
                                <div className={classes.moduleIcon}><IoCalendarSharp /></div>
                                <div className={classes.moduleName + ' px-1 pb-2'}>Calendar</div>
                            </div>
                        </Link>
                    </Col>

                    <Col xs={4}>
                        <Link to="/sys/automation" onClick={handelCloseModal}>
                            <div className={classes.moduleBox + ' shadow'} >
                                <div className={classes.moduleIcon}><FaProjectDiagram /></div>
                                <div className={classes.moduleName + ' px-1 pb-2'}>Automation</div>
                            </div>
                        </Link>
                    </Col>

                    <Col xs={4}>
                        <Link to="/sys/filesManager" onClick={handelCloseModal}>
                            <div className={classes.moduleBox + ' shadow'} >
                                <div className={classes.moduleIcon}><FaFolder /></div>
                                <div className={classes.moduleName + ' px-1 pb-2'}>Files Manager</div>
                            </div>
                        </Link>
                    </Col>

                    <Col xs={4}>
                        <Link to="/sys/mailbox" onClick={handelCloseModal}>
                            <div className={classes.moduleBox + ' shadow'} >
                                <div className={classes.moduleIcon}><TfiEmail /></div>
                                <div className={classes.moduleName + ' px-1 pb-2'}>Mailbox</div>
                            </div>
                        </Link>
                    </Col>

                    <Col xs={4}>
                        <Link to="/sys/settings" onClick={handelCloseModal}>
                            <div className={classes.moduleBox + ' shadow'} >
                                <div className={classes.moduleIcon}><FaGear /></div>
                                <div className={classes.moduleName + ' px-1 pb-2'}>Settings</div>
                            </div>
                        </Link>
                    </Col>
                </Row>
            </Offcanvas.Body>
        </Offcanvas>
    );
}

export default ModulesSideModal;